import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { Letter_Interface } from 'src/app/Interface/Letter_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SubjectLetterService } from 'src/app/Service/SubjectLetter/SubjectLetter.service';


@Component({
  selector: 'app-LetterRequestCustomer',
  templateUrl: './LetterRequestCustomer.component.html',
  styleUrls: ['./LetterRequestCustomer.component.scss']
})
export class LetterRequestCustomerComponent implements OnInit {
  Token: String = ""
  page: number = 0;
  page2: number = 0;
  Procssing: boolean = false

  Filter_customer: String = ''
  StartSearchDate: String = ''
  EndSearchDate: String = ''
  LetterType_Filter: String = '0'
  Subject_Filter: String = '0'
  DeviceName_Filter: String = ''
  LetterNumber_Filter: String = ''
  SubmitPeriodDate:string='1'

  constructor(
    private Nav_Service: NavService,
    private modalService: BsModalService,
    private Alertify_Service: AlertifyService,
    private SubjectLetter_Service: SubjectLetterService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token, 1097).subscribe(
      data => {
        this.ReadData_SubjectLetter()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )

  }

  DataList_LetterRequestCustomer: Array<LetterRequestCustomer_List_Interface> = []
  ReadData_LetterRequestCustomer(StartSearchDate, EndSearchDate, customer_id) {
    this.Procssing = true
    this.DataList_LetterRequestCustomer=[]
    this.LetterRequestCustomer_Service.GetLetterRequestCustomer(
      StartSearchDate,
      EndSearchDate,
      customer_id,
      Number(this.LetterType_Filter),
      Number(this.Subject_Filter),
      Number(this.SubmitPeriodDate),
      this.DeviceName_Filter,
      this.LetterNumber_Filter,
      this.Token).subscribe(
        data => {
          this.DataList_LetterRequestCustomer = data

          this.Procssing = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
  }

  DataList_Customer: Array<Customer_Interface> = []
  Select_Data_Customer: Customer_Interface = Empty_Customer_Interface()

  ReadData_Customer(StartSearchDate, EndSearchDate) {
    this.StartSearchDate = StartSearchDate
    this.EndSearchDate = EndSearchDate


    this.Select_Data_Customer = Empty_Customer_Interface()
    this.Procssing = true
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerCustomer(
      StartSearchDate,
      EndSearchDate,
      this.Filter_customer,
      Number(this.LetterType_Filter),
      Number(this.Subject_Filter),
      this.DeviceName_Filter,
      Number(this.SubmitPeriodDate),
      this.LetterNumber_Filter,
      this.Token).subscribe(
        data => {
          this.DataList_Customer = data

          this.Procssing = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
  }


  Set_Customer_For_Letter(item: Customer_Interface) {
    this.page2 = 0
    this.Select_Data_Customer = item
    this.ReadData_LetterRequestCustomer(this.StartSearchDate, this.EndSearchDate, item.id)
  }

  //#region SubjectLetter

  DataList_SubjectLetter: Array<General_Interface> = []
  ReadData_SubjectLetter() {

    this.SubjectLetter_Service.GetActiveList(this.Token).subscribe(
      data => {
        this.DataList_SubjectLetter = data
      }, error => {

      }
    )
  }

  //#endregion

}
